const TOKEN_KEY = "token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const clearSession = () => {
  localStorage.clear();
};

export const logout = () => {
  clearSession();

  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
};

export const isTokenExpired = (token = getToken()) => {
  if (!token) {
    return false;
  }

  const tokenParts = token.split(".");
  if (tokenParts.length !== 3) {
    return false;
  }

  try {
    const base64Payload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(window.atob(base64Payload));

    if (!payload.exp) {
      return false;
    }

    return payload.exp * 1000 <= Date.now();
  } catch (error) {
    return false;
  }
};

export const logoutIfTokenExpired = () => {
  if (isTokenExpired()) {
    logout();
    return true;
  }

  return false;
};
